// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.bg-soft-primary {
    background-color: rgba(102,88,221,.25);
}

.avatar-lg {
    height: 4.5rem;
    width: 4.5rem;
}

.rounded-circle {
    border-radius: 50%!important;
}

.border-primary {
    border: 1px solid #6658dd!important;
}

/* .border {
    border: 1px solid #6658dd!important;
} */

.text-primary {
    color: #6658dd!important;
}


.avatar-title {
    align-items: center;
    color: #fff;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
}

.font-22 {
    font-size: 22px!important;
}

.bg-soft-success {
    background-color: rgba(26,188,156,.25);
}

.border-success {
    border: 1px solid #1abc9c!important;
}

.text-success {
    color: #1abc9c!important;
}

.text-info {
    color: #4fc6e1!important;
}

.bg-soft-info {
    background-color: rgba(79,198,225,.25);
}

.border-info {
    border: 1px solid #4fc6e1!important;
}

.text-warning {
    color: #f7b84b!important;
}

.border-warning {
    border: 1px solid #f7b84b!important;
}

.bg-soft-warning {
    background-color: rgba(247,184,75,.25);
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/component/kpis/driver-breakdown/driver-breakdown.component.css"],"names":[],"mappings":"AAAA;IACI,mFAAmF;AACvF;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;GAEG;;AAEH;IACI,wBAAwB;AAC5B;;;AAGA;IAEI,mBAAmB;IACnB,WAAW;IAEX,aAAa;IACb,YAAY;IAEZ,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sCAAsC;AAC1C;AAFA,4lFAA4lF","sourcesContent":[".card {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n.bg-soft-primary {\n    background-color: rgba(102,88,221,.25);\n}\n\n.avatar-lg {\n    height: 4.5rem;\n    width: 4.5rem;\n}\n\n.rounded-circle {\n    border-radius: 50%!important;\n}\n\n.border-primary {\n    border: 1px solid #6658dd!important;\n}\n\n/* .border {\n    border: 1px solid #6658dd!important;\n} */\n\n.text-primary {\n    color: #6658dd!important;\n}\n\n\n.avatar-title {\n    -webkit-box-align: center;\n    align-items: center;\n    color: #fff;\n    display: -webkit-box;\n    display: flex;\n    height: 100%;\n    -webkit-box-pack: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.font-22 {\n    font-size: 22px!important;\n}\n\n.bg-soft-success {\n    background-color: rgba(26,188,156,.25);\n}\n\n.border-success {\n    border: 1px solid #1abc9c!important;\n}\n\n.text-success {\n    color: #1abc9c!important;\n}\n\n.text-info {\n    color: #4fc6e1!important;\n}\n\n.bg-soft-info {\n    background-color: rgba(79,198,225,.25);\n}\n\n.border-info {\n    border: 1px solid #4fc6e1!important;\n}\n\n.text-warning {\n    color: #f7b84b!important;\n}\n\n.border-warning {\n    border: 1px solid #f7b84b!important;\n}\n\n.bg-soft-warning {\n    background-color: rgba(247,184,75,.25);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
